import { useCallback } from "react";

import type { PlanCustomMailSettingInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { viewModelToDayTripPlanInputConverter, viewModelToPlanCustomMailSettingInputConverter } from "./composition";
import { DayTripPlanUpdateMutation } from "./mutation";

import type { ProductDayTripPlanFormModel } from "../../../type";

type Props = {
	resetViewModel: () => void;
};

export const useDayTripPlanEditMutation = ({ resetViewModel }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(DayTripPlanUpdateMutation);

	const onUpdate = useCallback(
		async (
			viewModel: ProductDayTripPlanFormModel["ViewModel"], //
		) => {
			showLoadingScreenCallback();

			try {
				const planInput = viewModelToDayTripPlanInputConverter({ viewModel });
				const planCustomMailSettingInput: PlanCustomMailSettingInput =
					viewModelToPlanCustomMailSettingInputConverter({
						viewModel,
					});

				// プラン更新
				const { errors: planErrors } = await mutationFunc({
					variables: {
						input: planInput,
						dayTripPlanCustomMailSettingInput: planCustomMailSettingInput,
					},
				});

				if (planErrors) {
					return;
				}

				notifyUserEventInfo({
					variant: "default",
					title: "日帰りプランを更新しました",
				});

				resetViewModel();
			} finally {
				hideLoadingScreenCallback();
			}
		},
		[hideLoadingScreenCallback, mutationFunc, resetViewModel, showLoadingScreenCallback],
	);

	return { onUpdate };
};
